module.exports = __webpack_public_path__ + "static/media/guitar.2483ad27.jpg";